// extracted by mini-css-extract-plugin
module.exports = {"merchantChargesContainer":"merchant-charges_merchantChargesContainer__1XsXU"};